import barba from '@barba/core';
import aos from './utils/aos';
import lazyImgs from './utils/lazyImgs';
import swipers from './utils/swipers';
import aniSwipers from './utils/anniversary-swipers';
import projectSwipers from './utils/anniversary-project-swiper';
import tippyHandler from "./utils/tippy";
import turnstileHandler from "./utils/turnstile";

const progressHandler = require('./utils/progressBar')
const html = document.documentElement

// on any internal link click
// document.addEventListener('click', function (e) {
// 	let target = e.target
// 	let isLink = target.matches('a')
// 	if (isLink) html.classList.add('is-loading') 
// })

barba.hooks.before(() => {
	console.log('Before')
	html.classList.add('is-loading') 
})

barba.hooks.beforeEnter(({ next, prev }) => {
	aos(next.container)
	lazyImgs(next.container)
	swipers(next.container)
	aniSwipers(next.container)
	projectSwipers(next.container)
	tippyHandler(next.container);
	turnstileHandler(next.container);
	//scroll to top
	// window.scrollTo(0, 0);
	// True Vertical height fix:
	function setVH() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	};
	setVH();
	window.addEventListener('resize', function() {
		setVH()
	});
})

barba.hooks.afterEnter(({ next }) => {
	// after enter hook stuff
	
	// global project disc progressbars on hover:
	let projectDiscEls = next.container.querySelectorAll('.project-disc')
	projectDiscEls.forEach(function (element, index) {

		let discHandler = progressHandler(element, {
			strokeWidth: 2,
			easing: 'easeInOut',
			duration: 600,
			color: '#6dc82c',
			trailColor: 'transparent',
			trailWidth: 0,
			svgStyle: null
		})
		let progress = element.dataset.progress || 0
		let complete = (element.dataset.complete === 'true')

		if (!complete) {
			if (window.innerWidth >= 1024) {
				element.addEventListener('mouseenter', function () {
					discHandler.animate(progress)
				})
				element.addEventListener('mouseleave', function () {
					discHandler.animate(0)
				})
			} else {
				discHandler.set(progress)
			}
		}

	})

})

barba.hooks.beforeLeave(({ next }) => {
	// bedfore leave hook stuff
	if (next.url.path === '/contact-us') {
		console.log('navigating to contact us')
		window.location.reload()
	}
})

// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

// initialise Barba.js
barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: false,
	preventRunning: true,
	prevent: ({ el }) => el.classList && el.classList.contains('prevent-barba')
})
